import React, { useState, useEffect, useCallback } from 'react';

function pick(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateNumbers() {
  const a = pick(1, 49);
  const b = pick(1, Math.min(49, 100 - a));
  if (a === b) return generateNumbers();
  return [a, b];
}

export function generateChoices(correct) {
  const choices = new Set([correct]);
  const offsets = [-10, 10, -2, 2, -20, 20, -5, 5, -1, 1, -15, 15];
  let attempts = 0;
  while (choices.size < 6 && attempts < 100) {
    const offset = offsets[Math.floor(Math.random() * offsets.length)];
    const candidate = correct + offset;
    if (candidate > 0 && candidate <= 100 && candidate !== correct) {
      choices.add(candidate);
    }
    attempts++;
  }
  while (choices.size < 6) {
    const r = Math.floor(Math.random() * 99) + 1;
    if (r !== correct) choices.add(r);
  }
  return [...choices].sort(() => Math.random() - 0.5);
}

export const BUTTON_COLORS = [
  '#FF6B6B', '#FF9F43', '#FECA57', '#48DBFB', '#1DD1A1', '#A29BFE',
];

export function useGameState(onFiveCorrect) {
  const [numA, setNumA] = useState(0);
  const [numB, setNumB] = useState(0);
  const [choices, setChoices] = useState([]);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [total, setTotal] = useState(0);
  const [streak, setStreak] = useState(0);
  const [correctInRow, setCorrectInRow] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [celebrating, setCelebrating] = useState(false);

  const newQuestion = useCallback(() => {
    const [a, b] = generateNumbers();
    setNumA(a);
    setNumB(b);
    setChoices(generateChoices(a + b));
    setSelected(null);
    setShowResult(false);
    setIsCorrect(false);
  }, []);

  useEffect(() => { newQuestion(); }, [newQuestion]);

  const handleChoice = (choice) => {
    if (selected !== null) return;
    const correct = numA + numB;
    const right = choice === correct;
    setSelected(choice);
    setIsCorrect(right);
    setShowResult(true);
    setTotal(t => t + 1);
    if (right) {
      setScore(s => s + 1);
      setStreak(s => s + 1);
      setCelebrating(true);
      setTimeout(() => setCelebrating(false), 1000);
      const newCorrectInRow = correctInRow + 1;
      setCorrectInRow(newCorrectInRow);
      if (newCorrectInRow >= 5) {
        setTimeout(() => onFiveCorrect(), right ? 1800 : 2500);
        return;
      }
    } else {
      setStreak(0);
      setCorrectInRow(0);
    }
    setTimeout(() => newQuestion(), right ? 1800 : 2500);
  };

  return {
    numA, numB, choices, selected, score, total,
    streak, correctInRow, showResult, isCorrect, celebrating,
    handleChoice,
    correct: numA + numB,
  };
}
